import menuItems from "../dashboard/menuItems";
import { path } from "../utils/routesPaths";
import { checkUserIsRole, roles } from "../utils/user";

const outerConditionsToMenus = (currentUser, clientOn) => {

    return {
        [path.investiments.balancesCollect]: [
            clientOn?.client?.is_able_transactions_current_month == true
        ]
    }
}

export default outerConditionsToMenus;